
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
{
	path: '/',
	meta: {
		title: '启东市六个一学生成长评价',
		noCache: true
	},
	name: 'xsd',
	component: () => import("../views/cityScreen.vue")
},
{
	path: '/school',
	meta: {
		title: '启东市南苑小学学生成长评价看板',
		noCache: true
	},
	name: 'sgp',
	component: () => import("../views/schoolScreen.vue")
}, 
// {
// 	path: '/pt',
// 	meta: {
// 		title: '31再生资源平台大数据面板',
// 		noCache: true
// 	},
// 	name: 'pt',
// 	component: () => import("../views/ptkbScreen.vue")
// }, 
// {
// 	path: '/fjzx',
// 	meta: {
// 		title: '分拣中心大数据面板',
// 		noCache: true
// 	},
// 	name: 'fjzx',
// 	component: () => import("../views/fjzxkbScreen.vue")
// },

]
const router = new VueRouter({
	mode: "history",
	routes
})
router.beforeEach((to, from, next) => {
	//beforeEach是router的钩子函数，在进入路由前执行
	if (to.meta.title) {
		//判断是否有标题
		// console.log(to.meta.title)
		document.title = to.meta.title
	} else {
		document.title = '31回收数据看板'
	}
	next()
})
export default router
